const TrustpilotLocaleMap = {
    en: {
        locale: 'en-US',
        tpurl: 'https://www.trustpilot.com/review/www.clubvillamar.com?stars=4&stars=5',
        template: '54ad5defc6454f065c28af8b',
        businessunit: '4be2e3a3000064000508664e'
    },
    fr: {
        locale: 'fr-FR',
        tpurl: 'https://fr.trustpilot.com/review/www.clubvillamar.fr?stars=4&stars=5',
        template: '54ad5defc6454f065c28af8b',
        businessunit: '519728b50000640005336383'
    },
    nl: {
        locale: 'nl-NL',
        tpurl: 'https://nl.trustpilot.com/review/www.clubvillamar.nl?stars=4&stars=5',
        template: '54ad5defc6454f065c28af8b',
        businessunit: '51b6fdf400006400053a6a1e'
    },
    de: {
        locale: 'de-DE',
        tpurl: 'https://de.trustpilot.com/review/www.clubvillamar.de?stars=4&stars=5',
        template: '54ad5defc6454f065c28af8b',
        businessunit: '51b6fe2900006400053a6a26'
    },
    es: {
        locale: 'es-ES',
        tpurl: 'https://es.trustpilot.com/review/www.clubvillamar.com?stars=4&stars=5',
        template: '54ad5defc6454f065c28af8b',
        businessunit: '4be2e3a3000064000508664e'
    },
    ru: {
        locale: 'ru-RU',
        tpurl: 'https://www.trustpilot.com/review/www.clubvillamar.com?stars=4&stars=5',
        template: '54ad5defc6454f065c28af8b',
        businessunit: '4be2e3a3000064000508664e'
    },
    da: {
        locale: 'da-DK',
        tpurl: 'https://www.trustpilot.com/review/www.clubvillamar.com?stars=4&stars=5',
        template: '54ad5defc6454f065c28af8b',
        businessunit: '4be2e3a3000064000508664e'
    },
    it: {
        locale: 'it-IT',
        tpurl: 'https://www.trustpilot.com/review/www.clubvillamar.com?stars=4&stars=5',
        template: '54ad5defc6454f065c28af8b',
        businessunit: '4be2e3a3000064000508664e'
    },
    no: {
        locale: 'no-NO',
        tpurl: 'https://www.trustpilot.com/review/www.clubvillamar.com?stars=4&stars=5',
        template: '54ad5defc6454f065c28af8b',
        businessunit: '4be2e3a3000064000508664e'
    },
    ca_es: {
        locale: 'es-ES',
        tpurl: 'https://www.trustpilot.com/review/www.clubvillamar.com?stars=4&stars=5',
        template: '54ad5defc6454f065c28af8b',
        businessunit: '4be2e3a3000064000508664e'
    }
};

let BaseURL = '/';

export {
    BaseURL,
    TrustpilotLocaleMap
}